module.exports = __webpack_public_path__ + "static/img/winners-fisrt.5beffaac.png";